import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toJS } from 'mobx';
import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
const feeModel = types.model({
  feeUnitType: types.union(types.literal(FEE_UNIT_TYPES.fixedAmount), types.literal(FEE_UNIT_TYPES.percentage)),
  value: types.union(types.number, types.string)
});
export const FeeStructureV2 = types.model({
  adminFee: types.maybeNull(feeModel),
  feesValidation: true,
  lateFee: types.maybeNull(feeModel),
  initialAdminFee: types.maybeNull(feeModel),
  initialLateFee: types.maybeNull(feeModel),
  paperStatementFee: types.maybeNull(feeModel),
  propertyId: types.optional(types.string, ''),
  unitSubscriptionFee: types.maybeNull(types.optional(feeModel, {
    value: 0,
    feeUnitType: FEE_UNIT_TYPES.fixedAmount
  }))
}).views(store => ({
  getPropertyFee(_ref) {
    let feeName = _ref.feeName;
    return toJS(store[feeName]);
  },
  getPropertyFees(_ref2) {
    let _ref2$feeNames = _ref2.feeNames,
      feeNames = _ref2$feeNames === void 0 ? [] : _ref2$feeNames;
    return feeNames.reduce((previousValue, currentValue) => {
      return _objectSpread(_objectSpread({}, previousValue), {
        ["".concat(currentValue)]: toJS(store[currentValue])
      });
    }, {});
  }
})).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyFeesDataAfterFetch(_ref3) {
      let data = _ref3.data;
      try {
        store.initialAdminFee = data.adminFee;
        store.initialLateFee = data.lateFee;
        Object.entries(data).forEach(_ref4 => {
          let _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];
          store["".concat(key)] = value;
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    clearFees() {
      try {
        store.adminFee = null;
        store.lateFee = null;
        store.paperStatementFee = null;
        store.unitSubscriptionFee = null;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateFee(_ref6) {
      let feeName = _ref6.feeName,
        value = _ref6.value,
        feeUnitType = _ref6.feeUnitType;
      try {
        if (value === null) {
          store[feeName] = value;
          return;
        }
        if (store[feeName] === null) {
          if (typeof value === 'number' && typeof feeUnitType === 'string') {
            store[feeName] = {
              value,
              feeUnitType
            };
          }
          return;
        }
        if (typeof value === 'number') {
          store[feeName].value = value;
        }
        if (typeof feeUnitType === 'string') {
          store[feeName].feeUnitType = feeUnitType;
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updateLateFee(data) {
      try {
        store.lateFee = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    validateFees(_ref7) {
      let value = _ref7.value;
      try {
        store.feesValidation = value;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});